import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConsultaPaginada, ConsultaPaginadaResultado, HttpHeadersUtils } from 'maestro-ng';
import {firstValueFrom} from 'rxjs';

export class EntityService<E, I> {

  constructor(public base: string, public http: HttpClient) {}

  public createJsonHttpHeaders(): HttpHeaders {
    return HttpHeadersUtils.contentTypeJson();
  }

  public path(path: string): string {
    return `${this.base}/${path}`;
  }

  public recuperarPorId(id: I): Promise<E> {
    return firstValueFrom(this.http.get<E>(this.path(`${id}`)));
  }

  public recuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<E>> {
    return firstValueFrom(this.http.post<ConsultaPaginadaResultado<E>>(this.path('recuperarPaginado'), consulta, { headers: this.createJsonHttpHeaders() }));
  }

  public recuperarSugestoes(termo: string): Promise<E[]> {
    return firstValueFrom(this.http.get<E[]>(this.path(`recuperarSugestoes?termo=${termo}`)));
  }

  public recuperarItens(): Promise<E[]> {
    return firstValueFrom(this.http.get<E[]>(this.path('recuperarItens')));
  }

  public excluirPorId(id: I): Promise<void> {
    return firstValueFrom(this.http.delete<void>(this.path(`${id}`)));
  }

  public inserir(entity: E): Promise<E> {
    return firstValueFrom(this.http.post<E>(this.path(''), entity, { headers: this.createJsonHttpHeaders() }));
  }

  public alterar(entity: E): Promise<E> {
    return firstValueFrom(this.http.put<E>(this.path(''), entity, { headers: this.createJsonHttpHeaders() }));
  }

  public salvar(fonteDados: E, id: I): Promise<E> {
    if (id === undefined || id === null) {
      return this.inserir(fonteDados);
    }
    else {
      return this.alterar(fonteDados);
    }
  }
}
